<form [formGroup]=saveAsForm>
    <div mat-dialog-content class="dialog-content">
        <h1 mat-dialog-title>SaveAs - Export File</h1>
        <mat-form-field appearance="fill" >
            <mat-label>File Name</mat-label>
            <input matInput type="text" name="exportFileName" formControlName="exportFileName">
        </mat-form-field>
        <div class="form-group">
            <mat-form-field class="first-control" style=" margin: 0.6rem 0.6rem 0 0;">
                <mat-label>Save as type</mat-label>
                <input matInput type="text"  name="fileFormat" formControlName="fileFormat" readonly>
            </mat-form-field>
            <mat-form-field class="second-control" style=" margin: 0.6rem 0.6rem 0 0;">
                <mat-label>Extension</mat-label>
                <mat-select  name="fileExtension" formControlName="fileExtension">
                    <mat-option *ngFor="let item of data.selectedFormat.extension" [value]="item">{{item}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button (click)="cancel()">Cancel</button>
        <button mat-raised-button color="primary"type="submit" (click)="onSubmit()">Ok</button>
    </div>
</form>